export default function isMobileChk() {
  const windowNav = window.navigator
  const thisUserAgent = windowNav.userAgent.toString()
  const iPhoneDecision = thisUserAgent.indexOf('iPhone')
  const AndroidDecision = thisUserAgent.indexOf('Android')
  let flg
  if (iPhoneDecision !== -1 || AndroidDecision !== -1) {
    flg = true
  } else {
    flg = false
  }
  return flg
}
